import type { Store } from '../api/types';

interface Props {
  store: Store;
  groupName: string | null;
  onOpenDesigns: () => void;
  onOpenQa: () => void;
}

const CADENCE_LABEL: Record<string, string> = {
  daily: 'daily', '2x-day': '2×/day', '3x-day': '3×/day', hourly: 'hourly',
};

/** One store on the landing page. No per-card data fetches: the service runs
 *  at min-instances 0 and N cards must never fan out N queries. */
export default function StoreCard({ store, groupName, onOpenDesigns, onOpenQa }: Props) {
  return (
    <article className="ff-card p-5 flex flex-col gap-4" data-testid={`store-card-${store.id}`}>
      <div className="min-w-0">
        <h3 className="font-display text-xl font-bold text-ff-ink truncate">{store.name}</h3>
        <p className="font-mono text-[11px] uppercase tracking-widish text-ff-mute">{store.id}</p>
      </div>
      <div className="flex flex-wrap gap-2">
        {groupName && <span className="ff-chip">{groupName}</span>}
        <span className="ff-chip">{CADENCE_LABEL[store.render_cadence ?? 'daily']}</span>
        <span className="ff-chip">
          {(store.default_cutout_mode ?? 'auto') === 'none' ? 'No cutout' : 'Cutout pipeline'}
        </span>
        {store.deletion_status === 'in_progress' && <span className="ff-chip text-ff-warning">deleting…</span>}
      </div>
      <div className="mt-auto flex gap-2">
        <button type="button" className="ff-btn-primary flex-1" onClick={onOpenDesigns}
                data-testid={`open-designs-${store.id}`}>Open designs</button>
        <button type="button" className="ff-btn-ghost" onClick={onOpenQa}
                data-testid={`open-qa-${store.id}`}>Cutout QA</button>
      </div>
    </article>
  );
}
